import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const pushSupported = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

const b64ToUint8 = (b64) => {
  const pad = '='.repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const subscribePush = async () => {
  const reg = await navigator.serviceWorker.register('/sw.js');
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await axios.get(`${API_URL}/push/public-key`);
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.key) });
  }
  await axios.post(`${API_URL}/push/subscribe`, { ...sub.toJSON(), user_agent: navigator.userAgent });
  return sub;
};

export const enablePush = async () => {
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Permissão recusada');
  await subscribePush();
  await axios.post(`${API_URL}/push/test`);
};
